import { render, staticRenderFns } from "./dialog-updategroup.vue?vue&type=template&id=497c3048&"
import script from "./dialog-updategroup.vue?vue&type=script&lang=js&"
export * from "./dialog-updategroup.vue?vue&type=script&lang=js&"
import style0 from "./dialog-updategroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports